import { format, formatDistanceStrict } from "date-fns";

export function getTimeToComplete(
  requested: number | Date,
  completed: number | Date | null
) {
  if (completed) {
    return formatDistanceStrict(requested, completed);
  }

  return "";
}

export function formatDate(requested: string) {
  return format(Date.parse(requested), "PP HH:mm:ss");
}
